import React from 'react';
import { useTranslation } from '../../i18n';
import { Modal } from './Modal';
import '../../App.css';

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
  <Modal
    isOpen={isOpen}
    onClose={onCancel}
    closeOnOverlayClick={false}
    contentStyle={{ maxWidth: '420px', textAlign: 'center' }}
  >
    <h2 style={{ margin: '0 0 0.75rem', fontSize: '1.35rem', color: 'var(--text-primary)' }}>{title}</h2>
    <p style={{ margin: '0 0 1.5rem', color: 'var(--text-secondary)', lineHeight: 1.5 }}>{message}</p>
    <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
      <button type="button" className="button" onClick={onCancel}>
        {cancelLabel ?? t('common.confirm.stay')}
      </button>
      <button type="button" className="button" onClick={onConfirm} style={{ backgroundColor: 'var(--color-danger, #ef4444)' }}>
        {confirmLabel ?? t('common.confirm.leave')}
      </button>
    </div>
  </Modal>
  );
};

export default ConfirmModal;
